// Product Form Constants
export const PRODUCT_FORM_LIMITS = {
  MAX_REDIRECT_URLS: 250,
  MAX_PRODUCT_NAME_LENGTH: 100,
  MAX_PRODUCT_DESCRIPTION_LENGTH: 300
} as const;


// Feature Flags
export const FEATURE_FLAGS = {
  // Controls visibility of Application Types and Redirect URLs in product form
  // When disabled, these fields are hidden from UI and not sent to API
  PRODUCT_METADATA_CONFIG: process.env.REACT_APP_PRODUCT_METADATA_CONFIG === 'true',
  // When true, Extension application type is shown in product form; false for stage/qa/prod, true for local dev
  SHOW_EXTENSION_TYPE: process.env.REACT_APP_SHOW_EXTENSION_TYPE === 'true'
} as const;

// External URLs
export const EXTERNAL_URLS = {
  CUSTOM_APP_TYPE_FORM: process.env.REACT_APP_CUSTOM_APP_TYPE_FORM_URL || '',
  /** Trimble Cloud Support — linked from public-product edit notice */
  CLOUD_SUPPORT:
    process.env.REACT_APP_CLOUD_SUPPORT_URL || 'https://support.trimble.com',
} as const;